module.exports = __webpack_public_path__ + "img/aikicthen.c53c59a7.png";